var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildings2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/buildings-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buildings-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.71634 4.30409C9.71634 4.47825 9.56967 4.62492 9.39551 4.62492H8.35967C6.37967 4.62492 4.76634 6.23825 4.76634 8.21825V16.6791C4.76634 16.8533 4.61967 16.9999 4.44551 16.9999H3.80384C2.71301 16.9999 1.83301 16.1199 1.83301 15.0291V4.30409C1.83301 3.21325 2.71301 2.33325 3.80384 2.33325H7.74551C8.83634 2.33325 9.71634 3.21325 9.71634 4.30409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.1665 4.30409V15.0291C20.1665 16.1199 19.2865 16.9999 18.1957 16.9999H17.6182C17.444 16.9999 17.2974 16.8533 17.2974 16.6791V8.21825C17.2974 6.23825 15.684 4.62492 13.704 4.62492H12.604C12.4299 4.62492 12.2832 4.47825 12.2832 4.30409C12.2832 3.21325 13.1632 2.33325 14.254 2.33325H18.1957C19.2865 2.33325 20.1665 3.21325 20.1665 4.30409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.7041 6H8.35994C7.1316 6 6.1416 6.99 6.1416 8.21833V18.4483C6.1416 19.6767 7.1316 20.6667 8.35994 20.6667H9.8541C10.1108 20.6667 10.3124 20.465 10.3124 20.2083V17.9167C10.3124 17.5408 10.6241 17.2292 10.9999 17.2292C11.3758 17.2292 11.6874 17.5408 11.6874 17.9167V20.2083C11.6874 20.465 11.8891 20.6667 12.1458 20.6667H13.7133C14.9324 20.6667 15.9224 19.6767 15.9224 18.4575V8.21833C15.9224 6.99 14.9324 6 13.7041 6ZM12.8333 14.0208H9.1666C8.79077 14.0208 8.4791 13.7092 8.4791 13.3333C8.4791 12.9575 8.79077 12.6458 9.1666 12.6458H12.8333C13.2091 12.6458 13.5208 12.9575 13.5208 13.3333C13.5208 13.7092 13.2091 14.0208 12.8333 14.0208ZM12.8333 11.2708H9.1666C8.79077 11.2708 8.4791 10.9592 8.4791 10.5833C8.4791 10.2075 8.79077 9.89583 9.1666 9.89583H12.8333C13.2091 9.89583 13.5208 10.2075 13.5208 10.5833C13.5208 10.9592 13.2091 11.2708 12.8333 11.2708Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings2);
export default __webpack_public_path__ + "static/media/buildings-2.08eed88ba1dfdc757351b2300933226d.svg";
export { ForwardRef as ReactComponent };